const actions = {
  MEMBER_CREATE: "MEMBER_CREATE",
  SELECTED_MEMBER: "SELECTED_MEMBER",
  GET_MEMBER_DATA: "GET_MEMBER_DATA",
  CLEAR_SELECTION:"CLEAR_SELECTION",

  stateDistrictActions : (data) =>{
    return {
      type: "GET_DATA",
      data,
    };
  }
};

export default actions;
